export default [
  {
    width: 24,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 38,
    header: {
      type: 'text',
      caption: 'Profit % per day',
    },
    cell: {
      type: 'slot',
      name: 'profit',
    },
  },
  {
    width: 38,
    header: {
      type: 'text',
      caption: 'Begin time',
    },
    cell: {
      type: 'slot',
      name: 'beginTime',
    },
  },
];
